<template>
  <div :class="['title-line', fixed?'title-line-fixed':'']" :style="{top: top}">
    <i class="el-icon-arrow-left"></i>
    <div class="title-item" v-for="(item, index) in title" :key="index" @click="handClick(item, index)">
      <span :class="['text',index == title.length-1?'text-big':'']">{{item}}</span>
      <i v-show="index!==title.length-1">/</i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'self-title',
  props: {
    title: {
      type: Array,
      default: () => {
        return ['标题', '标题']
      }
    },
    fixed: {
      type: Boolean,
      default: false
    },
    top: {
      type: String,
      default: '1vh'
    }
  },
  data() {
    return {
      data: ''
    }
  },

  methods: {
    handClick(item, index) {
      this.$emit('titleClick', item, index)
    }
  },
  watch: {},
  mounted() {}
}
</script>
<style lang="less" scoped>
.title-line-fixed {
  position: fixed;
  top: 0vh;
  z-index: 999;
}
.title-line {
  display: flex;
  align-items: center;
  min-width: 30vw;
  height: 5vh;
  border-radius: 1.2vh;
  font-size: 1.05vw;
  font-weight: bold;
  color: #666;
  line-height: 5vh;
  i {
    margin: 0 1vh;
    font-weight: bold;
    line-height: 5vh;
  }
  .text-big {
    color: #e4e7ff;
    font-size: 1vw;
  }
  .title-item {
    cursor: pointer;
  }
}
@media screen and (max-width: 768px) {
  .title-line-fixed {
    position: fixed;
    top: 0vh!important;
    z-index: 999;
  }
}
</style>
